module.exports = __webpack_public_path__ + "img/blue_ic_invoices.156b1b01.svg";